import { SvgIcon } from '@mui/material';

export default function QuestionIcon({ ...props }) {
  return (
    <SvgIcon {...props}>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 8.46429C11.1124 8.46429 10.3929 9.18383 10.3929 10.0714C10.3929 10.604 9.96113 11.0357 9.42857 11.0357C8.89601 11.0357 8.46429 10.604 8.46429 10.0714C8.46429 8.11871 10.0473 6.53571 12 6.53571C13.9527 6.53571 15.5357 8.11871 15.5357 10.0714C15.5357 11.5684 14.6058 12.8458 13.2956 13.362C13.1636 13.4139 13.0619 13.4874 13.0049 13.5513C12.9767 13.583 12.9671 13.6024 12.9643 13.6105C12.9625 14.1415 12.5314 14.5714 12 14.5714C11.4674 14.5714 11.0357 14.1397 11.0357 13.6071C11.0357 12.4953 11.9312 11.8266 12.5887 11.5676C13.1867 11.332 13.6071 10.7497 13.6071 10.0714C13.6071 9.18383 12.8876 8.46429 12 8.46429Z'
          fill='currentColor'
        />
        <path
          d='M12 17.7857C12.7101 17.7857 13.2857 17.2101 13.2857 16.5C13.2857 15.7899 12.7101 15.2143 12 15.2143C11.2899 15.2143 10.7143 15.7899 10.7143 16.5C10.7143 17.2101 11.2899 17.7857 12 17.7857Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 19.0714C15.9054 19.0714 19.0714 15.9054 19.0714 12C19.0714 8.09456 15.9054 4.92857 12 4.92857C8.09456 4.92857 4.92857 8.09456 4.92857 12C4.92857 15.9054 8.09456 19.0714 12 19.0714Z'
          fill='currentColor'
        />
      </svg>
    </SvgIcon>
  );
}
